import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cover" }
const _hoisted_2 = { class: "side-padded z-20 !text-white" }
const _hoisted_3 = { class: "modal-cover-title !text-white" }

import { computed } from 'vue'
import CloseButton from '@/components/CloseButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalCover',
  props: {
    image: {},
    coverOffset: {}
  },
  setup(__props: any) {

const props = __props

const backgroundPosition = computed(() =>
    props.coverOffset ? `${props.coverOffset[0]} ${props.coverOffset[1]}` : '50% 50%',
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal-cover",
      style: _normalizeStyle({ backgroundImage: `url(${__props.image})`, backgroundPosition: backgroundPosition.value })
    }, null, 4),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "gradient sm:h-36 h-48" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createVNode(CloseButton, {
        class: "absolute right-0 top-0",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      })
    ])
  ]))
}
}

})